var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartcitybremove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1B75BC;}\r\n\t.st1{fill:#27AAE1;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:none;stroke:#1B75BC;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#1B75BC;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{fill:#27AAE1;stroke:#1B75BC;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:#FFFFFF;stroke:#1B75BC;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st7{fill:#1B75BC;stroke:#1B75BC;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st8{fill:#27AAE1;stroke:#1B75BC;stroke-miterlimit:10;}\r\n\t.st9{fill:#FFFFFF;stroke:#1B75BC;stroke-miterlimit:10;}\r\n\t.st10{fill:#27AAE1;stroke:#1B75BC;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st11{fill:#1B75BC;stroke:#1B75BC;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st12{fill:#FFFFFF;stroke:#1B75BC;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st13{fill:none;stroke:#1B75BC;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M683.6,499.6L683.6,499.6c0,5.3-3.8,10.8-11.3,15.1L342.6,705c-13.6,7.9-34.4,8.7-46.2,1.9l-172.1-99.4 c-5.3-3.1-7.9-7.2-7.9-11.6v-31c0,4.3,2.6,8.5,7.9,11.6l5.4,3.1l166.7,96.2c11.8,6.8,32.6,5.9,46.2-1.9l327.6-189.1l2.1-1.2 c7.3-4.2,11.1-9.6,11.3-14.8L683.6,499.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M683.6,468.2v0.6c-0.1,5.1-4,10.5-11.3,14.8l-2.1,1.2L342.6,674c-13.6,7.9-34.4,8.7-46.2,1.9 l-166.7-96.2l-5.4-3.1c-5.3-3.1-7.9-7.2-7.9-11.6c0-5.2,3.8-10.8,11.3-15.1l329.7-190.4c13.6-7.9,34.4-8.7,46.2-1.9 L675.6,457C680.8,460,683.5,464,683.6,468.2z M361.2,639.3L638,479.6l-164-94.7l-9.5-5.5l-188.8,109l-87.9,50.8l6.2,3.6 l5.9,3.4L361.2,639.3z M602,444.2l11.2-6.5l-76.4-44.1l-11.2,6.5L602,444.2z M255.4,614.4c8.2-4.7,8.2-12.4,0-17.1 c-8.2-4.7-21.4-4.7-29.6,0c-8.2,4.7-8.2,12.4,0,17.1C234,619.1,247.2,619.1,255.4,614.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "638,479.5 361.2,639.3 199.7,546.1 193.9,542.7 187.7,539.1 275.6,488.4 464.5,379.3 474,384.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "613.2,437.8 602,444.2 525.6,400.1 536.8,393.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.4,597.3c8.2,4.7,8.2,12.4,0,17.1c-8.2,4.7-21.4,4.7-29.6,0c-8.2-4.7-8.2-12.4,0-17.1 C234,592.6,247.2,592.6,255.4,597.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116.4,565v31c0,4.3,2.6,8.5,7.9,11.6l172.1,99.4c11.8,6.8,32.6,5.9,46.2-1.9l329.7-190.3 c7.4-4.3,11.3-9.8,11.3-15.1v0l0-30.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116.4,565c0,4.3,2.6,8.5,7.9,11.6l5.4,3.1l166.7,96.2c11.8,6.8,32.6,5.9,46.2-1.9l327.6-189.1l2.1-1.2 c7.3-4.2,11.1-9.6,11.3-14.8v-0.6c-0.1-4.2-2.8-8.2-8-11.2l-172.1-99.4c-11.8-6.8-32.6-5.9-46.2,1.9L127.7,549.9 C120.2,554.2,116.4,559.7,116.4,565z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "613.2,437.8 602,444.2 525.6,400.1 536.8,393.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "199.7,546.1 193.9,542.7 187.7,539.1 275.6,488.4 464.5,379.3 474,384.9 638,479.5 361.2,639.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.4,614.4c8.2-4.7,8.2-12.4,0-17.1c-8.2-4.7-21.4-4.7-29.6,0c-8.2,4.7-8.2,12.4,0,17.1 C234,619.1,247.2,619.1,255.4,614.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "586.5,316.8 557,333.8 464.8,280.6 494.5,263.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "605.9,352.6 563.3,377.2 445.4,309.1 464.8,297.7 464.8,311 557,364.3 586.5,347.2  586.5,341.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "557,333.8 557,364.3 464.8,311 464.8,297.7 464.8,280.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "445.7,320.7 445.7,330.2 445.4,330.2 445.4,309.1 563.3,377.2 563.3,377.2 563.3,388.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "445.7,342.8 445.7,352.2 445.4,352.2 445.4,330.2 445.7,330.2 563.3,398 563.3,398  563.3,410.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "445.7,364.8 445.7,374.2 445.4,374.2 445.4,352.2 445.7,352.2 563.3,420 563.3,420.1  563.3,432.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "445.7,386.8 445.7,396.3 445.4,396.3 445.4,374.2 445.7,374.2 563.3,442.1 563.3,442.1  563.3,454.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "445.7,408.9 445.7,418.3 445.4,418.3 445.4,396.3 445.7,396.3 563.3,464.1 563.3,464.1  563.3,476.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "563.3,486.2 563.3,504.6 445.4,436.5 445.4,418.3 445.7,418.3 563.3,486.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "563.3,476.7 563.3,486.2 445.7,418.3 445.7,408.9 563.3,476.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "605.9,452.2 605.9,461.6 563.3,486.2 563.3,486.2 563.3,476.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "605.9,430.1 605.9,439.6 563.3,464.1 563.3,454.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "563.3,454.7 563.3,464.1 445.7,396.3 445.7,386.8 563.3,454.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "563.3,432.7 563.3,442.1 445.7,374.2 445.7,364.8 563.3,432.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "605.9,408.1 605.9,417.5 563.3,442.1 563.3,432.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "605.9,386 605.9,395.5 563.3,420.1 563.3,410.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "563.3,410.6 563.3,420 445.7,352.2 445.7,342.8 563.3,410.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "605.9,364 605.9,373.5 563.3,398 563.3,398 563.3,388.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "563.3,388.6 563.3,398 445.7,330.2 445.7,320.7 563.3,388.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "586.5,341.5 586.5,347.2 557,364.3 557,333.8 586.5,316.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "563.3,486.2 605.9,461.6 605.9,480 563.3,504.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "605.9,439.6 605.9,452.2 563.3,476.7 563.3,464.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "605.9,417.5 605.9,430.1 563.3,454.7 563.3,442.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "605.9,395.5 605.9,408.1 563.3,432.7 563.3,432.6 563.3,420.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "563.3,398 605.9,373.5 605.9,386 563.3,410.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "605.9,352.6 605.9,364 563.3,388.6 563.3,377.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "557,364.3 464.8,311 464.8,297.7 464.8,280.6 557,333.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "557,333.8 586.5,316.8 586.5,341.5 586.5,347.2 557,364.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 586.5,
    y1: 316.8,
    x2: 494.5,
    y2: 263.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 464.8,
    y1: 280.6,
    x2: 494.5,
    y2: 263.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "563.3,486.2 563.3,504.6 563.3,504.6 563.3,504.6 605.9,480 605.9,461.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "563.3,464.1 563.3,476.7 563.3,476.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "563.3,442.1 563.3,454.7 563.3,454.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "563.3,420.1 563.3,432.6 563.3,432.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "563.3,398 563.3,410.6 563.3,410.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "605.9,364 605.9,352.6 563.3,377.2 563.3,377.2 563.3,388.6 563.3,388.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 605.9,
    y1: 386,
    x2: 605.9,
    y2: 373.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 605.9,
    y1: 408.1,
    x2: 605.9,
    y2: 395.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 605.9,
    y1: 430.1,
    x2: 605.9,
    y2: 417.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 605.9,
    y1: 452.2,
    x2: 605.9,
    y2: 439.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "563.3,398 563.3,398 605.9,373.5 605.9,364 563.3,388.6 563.3,388.6 563.3,398  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "563.3,420.1 563.3,420.1 605.9,395.5 605.9,386 563.3,410.6 563.3,410.6 563.3,420  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "563.3,442.1 563.3,442.1 605.9,417.5 605.9,408.1 563.3,432.7 563.3,432.7 563.3,442.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "563.3,464.1 563.3,464.1 605.9,439.6 605.9,430.1 563.3,454.7 563.3,454.7 563.3,464.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "563.3,486.2 563.3,486.2 605.9,461.6 605.9,452.2 563.3,476.7 563.3,476.7 563.3,486.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "563.3,388.6 563.3,377.2 445.4,309.1 445.4,330.2 445.4,352.2 445.4,374.2 445.4,396.3  445.4,418.3 445.4,436.5 563.3,504.6 563.3,504.6 563.3,486.2 563.3,486.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "563.3,410.6 563.3,398 563.3,398  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 563.3,
    y1: 432.6,
    x2: 563.3,
    y2: 420.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 563.3,
    y1: 454.7,
    x2: 563.3,
    y2: 442.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 563.3,
    y1: 476.7,
    x2: 563.3,
    y2: 464.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "445.7,330.2 563.3,398 563.3,398 563.3,388.6 563.3,388.6 445.7,320.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "445.7,352.2 563.3,420 563.3,420.1 563.3,410.6 563.3,410.6 445.7,342.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "445.7,374.2 563.3,442.1 563.3,442.1 563.3,432.7 563.3,432.6 563.3,432.6 445.7,364.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "445.7,396.3 563.3,464.1 563.3,464.1 563.3,454.7 563.3,454.7 445.7,386.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "445.7,418.3 563.3,486.2 563.3,486.2 563.3,476.7 563.3,476.7 445.7,408.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 605.9,
    y1: 352.6,
    x2: 586.5,
    y2: 341.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 445.4,
    y1: 309.1,
    x2: 464.8,
    y2: 297.7
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M296.6,123.2c-9.6,0-18.3,3.9-24.6,10.1c-3.1-1.3-6.5-2-10.1-2c-14.6,0-26.4,11.7-26.4,26.2 c0,3.8,3.1,6.9,7,6.9h81.8c3.8,0,7-3.1,7-6.9C331.3,138.6,315.8,123.2,296.6,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M583,200c13.1,0,24.6,7.2,30.4,17.9c3.1-2,6.8-3.2,10.8-3.2c10.9,0,19.8,8.8,19.8,19.6c0,3.8-3.1,6.9-7,6.9 h-81.8c-3.8,0-7-3.1-7-6.9C548.3,215.4,563.8,200,583,200z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M150.7,328.5c-7.6-9.3-19.3-15.2-32.3-15.2c-13.1,0-24.7,6-32.3,15.2c-0.8-0.1-1.5-0.1-2.3-0.1 c-14.6,0-26.4,11.7-26.4,26.2c0,3.8,3.1,6.9,7,6.9h104.2c3.8,0,7-3.1,7-6.9C175.5,340.7,164.6,329.3,150.7,328.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448,276.6v184.8l-35.2,20.3V296.9L448,276.6z M442.2,447.7v-76.2l-8.9,5.1v76.2L442.2,447.7z  M442.2,364.4v-76.2l-8.9,5.1v76.2L442.2,364.4z M427.5,456.2V380l-8.9,5.1v76.2L427.5,456.2z M427.5,372.9v-76.2l-8.9,5.1 V378L427.5,372.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "448,276.6 412.9,296.9 377.7,276.6 391.2,268.7 391.2,276.3 412.9,288.8 434.5,276.3  434.5,268.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "442.2,371.5 442.2,447.7 433.4,452.9 433.4,376.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "442.2,288.2 442.2,364.4 433.4,369.5 433.4,293.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "434.5,268.7 434.5,276.3 412.9,288.8 412.9,233.3 434.5,220.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "434.5,220.8 412.9,233.3 391.2,220.8 412.9,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "427.5,380 427.5,456.2 418.6,461.4 418.6,385.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "427.5,296.7 427.5,372.9 418.6,378 418.6,301.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.9,296.9v184.8l-35.2-20.3V276.6L412.9,296.9z M407.1,461.4v-76.2l-8.9-5.1v76.2L407.1,461.4z  M407.1,378v-76.2l-8.9-5.1v76.2L407.1,378z M392.4,452.9v-76.2l-8.9-5.1v76.2L392.4,452.9z M392.4,369.5v-76.2l-8.9-5.1 v76.2L392.4,369.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "412.9,233.3 412.9,288.8 391.2,276.3 391.2,268.7 391.2,220.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "407.1,385.1 407.1,461.4 398.2,456.2 398.2,380  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "407.1,301.8 407.1,378 398.2,372.9 398.2,296.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "392.4,376.7 392.4,452.9 383.5,447.7 383.5,371.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "392.4,293.4 392.4,369.5 383.5,364.4 383.5,288.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "412.9,481.6 377.7,461.3 377.7,276.6 412.9,296.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "407.1,378 398.2,372.9 398.2,296.7 407.1,301.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "392.4,369.5 383.5,364.4 383.5,288.2 392.4,293.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "407.1,461.4 398.2,456.2 398.2,380 407.1,385.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "392.4,452.9 383.5,447.7 383.5,371.5 392.4,376.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "448,276.6 448,461.3 412.9,481.6 412.9,296.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "442.2,364.4 433.4,369.5 433.4,293.4 442.2,288.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "427.5,372.9 418.6,378 418.6,301.8 427.5,296.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "442.2,447.7 433.4,452.9 433.4,376.7 442.2,371.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "427.5,456.2 418.6,461.4 418.6,385.1 427.5,380  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 434.5,
    y1: 268.7,
    x2: 448,
    y2: 276.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 377.7,
    y1: 276.6,
    x2: 391.2,
    y2: 268.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "412.9,233.3 391.2,220.8 391.2,268.7 391.2,276.3 412.9,288.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "434.5,220.8 412.9,233.3 412.9,288.8 434.5,276.3 434.5,268.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "391.2,220.8 412.9,208 434.5,220.8  "
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "420.1,218.9 420.1,221.9 411.4,227 411.4,174.6 420.1,169.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "420.1,169.6 411.4,174.6 402.6,169.6 411.4,164.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "411.4,174.6 411.4,227 402.6,221.9 402.6,218.9 402.6,169.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "411.4,174.6 402.6,169.6 402.6,218.9 402.6,221.9 411.4,227  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "420.1,169.6 411.4,174.6 411.4,227 420.1,221.9 420.1,218.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "402.6,169.6 411.4,164.5 420.1,169.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "239.1,377.6 268.6,394.6 360.8,341.4 331,324  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "219.7,413.4 262.3,438 380.2,369.9 360.8,358.5 360.8,371.8 268.6,425 239.1,408 239.1,402.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "268.6,394.6 268.6,425 360.8,371.8 360.8,358.5 360.8,341.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "379.9,381.5 379.9,391 380.2,391 380.2,369.9 262.3,438 262.3,438 262.3,449.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "379.9,403.5 379.9,413 380.2,413 380.2,391 379.9,391 262.3,458.8 262.3,458.8 262.3,471.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "379.9,425.6 379.9,435 380.2,435 380.2,413 379.9,413 262.3,480.8 262.3,480.9 262.3,493.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "379.9,447.6 379.9,457 380.2,457 380.2,435 379.9,435 262.3,502.9 262.3,502.9 262.3,515.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "379.9,469.6 379.9,479.1 380.2,479.1 380.2,457 379.9,457 262.3,524.9 262.3,524.9  262.3,537.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "262.3,547 262.3,565.4 380.2,497.3 380.2,479.1 379.9,479.1 262.3,547  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "262.3,537.5 262.3,547 379.9,479.1 379.9,469.6 262.3,537.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "219.7,513 219.7,522.4 262.3,547 262.3,547 262.3,537.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "219.7,490.9 219.7,500.4 262.3,524.9 262.3,515.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "262.3,515.5 262.3,524.9 379.9,457 379.9,447.6 262.3,515.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "262.3,493.5 262.3,502.9 379.9,435 379.9,425.6 262.3,493.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "219.7,468.9 219.7,478.3 262.3,502.9 262.3,493.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "219.7,446.8 219.7,456.3 262.3,480.9 262.3,471.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "262.3,471.4 262.3,480.8 379.9,413 379.9,403.5 262.3,471.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "219.7,424.8 219.7,434.2 262.3,458.8 262.3,458.8 262.3,449.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "262.3,449.4 262.3,458.8 379.9,391 379.9,381.5 262.3,449.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "239.1,402.3 239.1,408 268.6,425 268.6,394.6 239.1,377.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "262.3,547 219.7,522.4 219.7,540.8 262.3,565.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "219.7,500.4 219.7,513 262.3,537.5 262.3,524.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "219.7,478.3 219.7,490.9 262.3,515.5 262.3,502.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "219.7,456.3 219.7,468.9 262.3,493.5 262.3,493.4 262.3,480.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "262.3,458.8 219.7,434.2 219.7,446.8 262.3,471.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "219.7,413.4 219.7,424.8 262.3,449.4 262.3,438  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "268.6,425 360.8,371.8 360.8,358.5 360.8,341.4 268.6,394.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "268.6,394.6 239.1,377.6 239.1,402.3 239.1,408 268.6,425  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 239.1,
    y1: 377.6,
    x2: 331,
    y2: 324
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 360.8,
    y1: 341.4,
    x2: 331,
    y2: 324
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "262.3,547 262.3,565.4 262.3,565.4 262.3,565.4 219.7,540.8 219.7,522.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "262.3,524.9 262.3,537.5 262.3,537.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "262.3,502.9 262.3,515.5 262.3,515.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "262.3,480.9 262.3,493.4 262.3,493.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "262.3,458.8 262.3,471.4 262.3,471.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "219.7,424.8 219.7,413.4 262.3,438 262.3,438 262.3,449.4 262.3,449.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 219.7,
    y1: 446.8,
    x2: 219.7,
    y2: 434.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 219.7,
    y1: 468.9,
    x2: 219.7,
    y2: 456.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 219.7,
    y1: 490.9,
    x2: 219.7,
    y2: 478.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 219.7,
    y1: 513,
    x2: 219.7,
    y2: 500.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "262.3,458.8 262.3,458.8 219.7,434.2 219.7,424.8 262.3,449.4 262.3,449.4 262.3,458.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "262.3,480.9 262.3,480.9 219.7,456.3 219.7,446.8 262.3,471.4 262.3,471.4 262.3,480.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "262.3,502.9 262.3,502.9 219.7,478.3 219.7,468.9 262.3,493.5 262.3,493.5 262.3,502.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "262.3,524.9 262.3,524.9 219.7,500.4 219.7,490.9 262.3,515.5 262.3,515.5 262.3,524.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "262.3,547 262.3,547 219.7,522.4 219.7,513 262.3,537.5 262.3,537.5 262.3,547  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "262.3,449.4 262.3,438 380.2,369.9 380.2,391 380.2,413 380.2,435 380.2,457 380.2,479.1  380.2,497.3 262.3,565.4 262.3,565.4 262.3,547 262.3,547  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "262.3,471.4 262.3,458.8 262.3,458.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 262.3,
    y1: 493.4,
    x2: 262.3,
    y2: 480.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 262.3,
    y1: 515.5,
    x2: 262.3,
    y2: 502.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 262.3,
    y1: 537.5,
    x2: 262.3,
    y2: 524.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "379.9,391 262.3,458.8 262.3,458.8 262.3,449.4 262.3,449.4 379.9,381.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "379.9,413 262.3,480.8 262.3,480.9 262.3,471.4 262.3,471.4 379.9,403.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "379.9,435 262.3,502.9 262.3,502.9 262.3,493.5 262.3,493.4 262.3,493.4 379.9,425.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "379.9,457 262.3,524.9 262.3,524.9 262.3,515.5 262.3,515.5 379.9,447.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "379.9,479.1 262.3,547 262.3,547 262.3,537.5 262.3,537.5 379.9,469.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 219.7,
    y1: 413.4,
    x2: 239.1,
    y2: 402.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 380.2,
    y1: 369.9,
    x2: 360.8,
    y2: 358.5
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "445.4,414.8 445.4,428.3 407.4,406.4 407.4,398.5 407.4,393  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "483.3,393 445.4,414.8 407.4,393 445.4,371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "500.2,408.4 445.4,440 390.5,408.4 407.4,398.5 407.4,406.4 445.4,428.3 483.3,406.4  483.3,398.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "483.3,398.5 483.3,406.4 445.4,428.3 445.4,414.8 483.3,393  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "405.8,448.1 405.8,457.8 397.5,453 397.5,443.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "422,476.3 422,485.9 413.7,481.1 413.7,471.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "438.3,466.9 438.3,476.5 430,471.7 430,462.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "438.3,523.3 438.3,532.9 430,528.1 430,518.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "405.8,485.7 405.8,495.3 397.5,490.5 397.5,480.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "405.8,504.5 405.8,514.1 397.5,509.3 397.5,499.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "405.8,523.3 405.8,532.9 397.5,528.1 397.5,518.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "438.3,504.5 438.3,514.1 430,509.3 430,499.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "405.8,466.9 405.8,476.5 397.5,471.7 397.5,462.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "422,513.9 422,523.5 413.7,518.7 413.7,509.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "438.3,542.1 438.3,551.7 430,546.9 430,537.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "422,438.8 422,448.4 413.7,443.6 413.7,434  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "438.3,485.7 438.3,495.3 430,490.5 430,480.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "422,457.5 422,467.1 413.7,462.3 413.7,452.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.4,440v129.1l-54.9-31.7V408.4L445.4,440z M438.3,551.7v-9.6l-8.3-4.8v9.6L438.3,551.7z  M438.3,532.9v-9.6l-8.3-4.8v9.6L438.3,532.9z M438.3,514.1v-9.6l-8.3-4.8v9.6L438.3,514.1z M438.3,495.3v-9.6l-8.3-4.8v9.6 L438.3,495.3z M438.3,476.5v-9.6l-8.3-4.8v9.6L438.3,476.5z M438.3,457.8v-9.6l-8.3-4.8v9.6L438.3,457.8z M422,542.3v-9.6 l-8.3-4.8v9.6L422,542.3z M422,523.5v-9.6l-8.3-4.8v9.6L422,523.5z M422,504.7v-9.6l-8.3-4.8v9.6L422,504.7z M422,485.9 v-9.6l-8.3-4.8v9.6L422,485.9z M422,467.1v-9.6l-8.3-4.8v9.6L422,467.1z M422,448.4v-9.6l-8.3-4.8v9.6L422,448.4z  M405.8,532.9v-9.6l-8.3-4.8v9.6L405.8,532.9z M405.8,514.1v-9.6l-8.3-4.8v9.6L405.8,514.1z M405.8,495.3v-9.6l-8.3-4.8v9.6 L405.8,495.3z M405.8,476.5v-9.6l-8.3-4.8v9.6L405.8,476.5z M405.8,457.8v-9.6l-8.3-4.8v9.6L405.8,457.8z M405.8,439v-9.6 l-8.3-4.8v9.6L405.8,439z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "422,532.7 422,542.3 413.7,537.5 413.7,527.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "405.8,429.4 405.8,439 397.5,434.2 397.5,424.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "438.3,448.1 438.3,457.8 430,453 430,443.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "422,495.1 422,504.7 413.7,499.9 413.7,490.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500.2,408.4v129.1l-54.9,31.7V440L500.2,408.4z M493.2,528.1v-9.6l-8.3,4.8v9.6L493.2,528.1z  M493.2,509.3v-9.6l-8.3,4.8v9.6L493.2,509.3z M493.2,490.5v-9.6l-8.3,4.8v9.6L493.2,490.5z M493.2,471.7v-9.6l-8.3,4.8v9.6 L493.2,471.7z M493.2,453v-9.6l-8.3,4.8v9.6L493.2,453z M493.2,434.2v-9.6l-8.3,4.8v9.6L493.2,434.2z M477,537.5v-9.6 l-8.3,4.8v9.6L477,537.5z M477,518.7v-9.6l-8.3,4.8v9.6L477,518.7z M477,499.9v-9.6l-8.3,4.8v9.6L477,499.9z M477,481.1 v-9.6l-8.3,4.8v9.6L477,481.1z M477,462.3v-9.6l-8.3,4.8v9.6L477,462.3z M477,443.6V434l-8.3,4.8v9.6L477,443.6z  M460.7,546.9v-9.6l-8.3,4.8v9.6L460.7,546.9z M460.7,528.1v-9.6l-8.3,4.8v9.6L460.7,528.1z M460.7,509.3v-9.6l-8.3,4.8v9.6 L460.7,509.3z M460.7,490.5v-9.6l-8.3,4.8v9.6L460.7,490.5z M460.7,471.7v-9.6l-8.3,4.8v9.6L460.7,471.7z M460.7,453v-9.6 l-8.3,4.8v9.6L460.7,453z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "493.2,480.9 493.2,490.5 484.9,495.3 484.9,485.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "493.2,518.5 493.2,528.1 484.9,532.9 484.9,523.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "493.2,443.3 493.2,453 484.9,457.8 484.9,448.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "493.2,424.6 493.2,434.2 484.9,439 484.9,429.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "460.7,537.3 460.7,546.9 452.4,551.7 452.4,542.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "477,527.9 477,537.5 468.6,542.3 468.6,532.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "477,490.3 477,499.9 468.6,504.7 468.6,495.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "460.7,499.7 460.7,509.3 452.4,514.1 452.4,504.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "460.7,480.9 460.7,490.5 452.4,495.3 452.4,485.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "477,509.1 477,518.7 468.6,523.5 468.6,513.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "477,452.7 477,462.3 468.6,467.1 468.6,457.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "493.2,499.7 493.2,509.3 484.9,514.1 484.9,504.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "477,434 477,443.6 468.6,448.4 468.6,438.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "493.2,462.1 493.2,471.7 484.9,476.5 484.9,466.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "460.7,462.1 460.7,471.7 452.4,476.5 452.4,466.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "460.7,518.5 460.7,528.1 452.4,532.9 452.4,523.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "477,471.5 477,481.1 468.6,485.9 468.6,476.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "460.7,443.4 460.7,453 452.4,457.8 452.4,448.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "445.4,569.2 390.5,537.5 390.5,408.4 445.4,440  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "422,448.4 413.7,443.6 413.7,434 422,438.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "405.8,439 397.5,434.2 397.5,424.6 405.8,429.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "438.3,457.8 430,453 430,443.4 438.3,448.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "422,467.1 413.7,462.3 413.7,452.7 422,457.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "405.8,457.8 397.5,453 397.5,443.3 405.8,448.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "438.3,476.5 430,471.7 430,462.1 438.3,466.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "422,485.9 413.7,481.1 413.7,471.5 422,476.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "405.8,476.5 397.5,471.7 397.5,462.1 405.8,466.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "438.3,495.3 430,490.5 430,480.9 438.3,485.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "422,504.7 413.7,499.9 413.7,490.3 422,495.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "405.8,495.3 397.5,490.5 397.5,480.9 405.8,485.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "438.3,514.1 430,509.3 430,499.7 438.3,504.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "422,523.5 413.7,518.7 413.7,509.1 422,513.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "405.8,514.1 397.5,509.3 397.5,499.7 405.8,504.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "438.3,532.9 430,528.1 430,518.5 438.3,523.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "422,542.3 413.7,537.5 413.7,527.9 422,532.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "405.8,532.9 397.5,528.1 397.5,518.5 405.8,523.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "438.3,551.7 430,546.9 430,537.3 438.3,542.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "445.4,440 500.2,408.4 500.2,537.5 445.4,569.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "477,443.6 468.6,448.4 468.6,438.8 477,434  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "460.7,453 452.4,457.8 452.4,448.1 460.7,443.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "493.2,434.2 484.9,439 484.9,429.4 493.2,424.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "477,462.3 468.6,467.1 468.6,457.5 477,452.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "460.7,471.7 452.4,476.5 452.4,466.9 460.7,462.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "493.2,453 484.9,457.8 484.9,448.1 493.2,443.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "477,481.1 468.6,485.9 468.6,476.3 477,471.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "460.7,490.5 452.4,495.3 452.4,485.7 460.7,480.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "493.2,471.7 484.9,476.5 484.9,466.9 493.2,462.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "477,499.9 468.6,504.7 468.6,495.1 477,490.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "460.7,509.3 452.4,514.1 452.4,504.5 460.7,499.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "493.2,490.5 484.9,495.3 484.9,485.7 493.2,480.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "477,518.7 468.6,523.5 468.6,513.9 477,509.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "460.7,528.1 452.4,532.9 452.4,523.3 460.7,518.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "493.2,509.3 484.9,514.1 484.9,504.5 493.2,499.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "477,537.5 468.6,542.3 468.6,532.7 477,527.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "460.7,546.9 452.4,551.7 452.4,542.1 460.7,537.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "493.2,528.1 484.9,532.9 484.9,523.3 493.2,518.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 483.3,
    y1: 398.5,
    x2: 500.2,
    y2: 408.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 390.5,
    y1: 408.4,
    x2: 407.4,
    y2: 398.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "445.4,428.3 483.3,406.4 483.3,398.5 483.3,393 445.4,414.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "445.4,414.8 407.4,393 407.4,398.5 407.4,406.4 445.4,428.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "407.4,393 445.4,371 483.3,393  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.9,409.2V594l-35.2,20.3V429.5L390.9,409.2z M385.1,580.3v-76.2l-8.9,5.1v76.2L385.1,580.3z  M385.1,497v-76.2l-8.9,5.1v76.2L385.1,497z M370.4,588.8v-76.2l-8.9,5.1V594L370.4,588.8z M370.4,505.5v-76.2l-8.9,5.1 v76.2L370.4,505.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "390.9,409.2 355.7,429.5 320.5,409.2 334,401.3 334,408.9 355.7,421.4 377.4,408.9  377.4,401.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "385.1,504.1 385.1,580.3 376.2,585.5 376.2,509.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "385.1,420.8 385.1,497 376.2,502.2 376.2,426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "377.4,401.3 377.4,408.9 355.7,421.4 355.7,365.9 377.4,353.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "377.4,353.4 355.7,365.9 334,353.4 355.7,340.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "370.4,512.6 370.4,588.8 361.5,594 361.5,517.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "370.4,429.3 370.4,505.5 361.5,510.6 361.5,434.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.7,429.5v184.8L320.5,594V409.2L355.7,429.5z M349.9,594v-76.2l-8.9-5.1v76.2L349.9,594z  M349.9,510.6v-76.2l-8.9-5.1v76.2L349.9,510.6z M335.2,585.5v-76.2l-8.9-5.1v76.2L335.2,585.5z M335.2,502.2V426l-8.9-5.1 V497L335.2,502.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "355.7,365.9 355.7,421.4 334,408.9 334,401.3 334,353.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "349.9,517.8 349.9,594 341,588.8 341,512.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "349.9,434.5 349.9,510.6 341,505.5 341,429.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "335.2,509.3 335.2,585.5 326.3,580.3 326.3,504.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "335.2,426 335.2,502.2 326.3,497 326.3,420.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "355.7,614.3 320.5,594 320.5,409.2 355.7,429.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "349.9,510.6 341,505.5 341,429.3 349.9,434.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "335.2,502.2 326.3,497 326.3,420.8 335.2,426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "349.9,594 341,588.8 341,512.6 349.9,517.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "335.2,585.5 326.3,580.3 326.3,504.1 335.2,509.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "390.9,409.2 390.9,594 355.7,614.3 355.7,429.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "385.1,497 376.2,502.2 376.2,426 385.1,420.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "370.4,505.5 361.5,510.6 361.5,434.5 370.4,429.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "385.1,580.3 376.2,585.5 376.2,509.3 385.1,504.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "370.4,588.8 361.5,594 361.5,517.8 370.4,512.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 377.4,
    y1: 401.3,
    x2: 390.9,
    y2: 409.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 320.5,
    y1: 409.2,
    x2: 334,
    y2: 401.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "355.7,365.9 334,353.4 334,401.3 334,408.9 355.7,421.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "377.4,353.4 355.7,365.9 355.7,421.4 377.4,408.9 377.4,401.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "334,353.4 355.7,340.6 377.4,353.4  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M277.4,545.9c0,0.2,0,0.3,0,0.5c-1.2,1-2.8,1.5-4.4,1.5h-4.1h-4.4c-4,0-7.3-3.3-7.3-7.3v-19.7 c0-4,3.3-7.3,7.3-7.3h8.5c1.6,0,3.2,0.6,4.4,1.5V545.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M328,513.1v19.7c0,4-3.3,7.3-7.3,7.3h-4.2h-4.2c-1.6,0-3.2-0.5-4.4-1.5c-1.8-1.3-2.9-3.5-2.9-5.8v-19.7 c0-2.4,1.1-4.5,2.9-5.8c1.2-0.9,2.8-1.5,4.4-1.5h8.5C324.7,505.8,328,509.1,328,513.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M292.6,553.2h-7.9c-3.9,0-7.1-3-7.3-6.8c0-0.2,0-0.3,0-0.5v-30.8V496c0-4,3.3-7.3,7.3-7.3h15.7 c4,0,7.3,3.3,7.3,7.3v11.2c-1.8,1.3-2.9,3.5-2.9,5.8v19.7c0,2.4,1.1,4.5,2.9,5.8v7.3c0,4-3.3,7.3-7.3,7.3H292.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "292.6,577.1 292.6,562.7 292.6,557.7 292.6,553.2 292.6,543.8 292.6,536.2 292.6,529  292.6,521.4 292.6,510.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 292.6,
    y1: 521.4,
    x2: 283.8,
    y2: 512.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 292.6,
    y1: 529,
    x2: 301.4,
    y2: 520.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 292.6,
    y1: 536.2,
    x2: 283.8,
    y2: 527.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 292.6,
    y1: 543.8,
    x2: 301.4,
    y2: 535
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M307.8,507.3V496c0-4-3.3-7.3-7.3-7.3h-15.7c-4,0-7.3,3.3-7.3,7.3v19.1v30.8c0,0.2,0,0.3,0,0.5 c0.2,3.8,3.4,6.8,7.3,6.8h7.9h7.9c4,0,7.3-3.3,7.3-7.3v-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M277.4,515.1C277.4,515.1,277.4,515.1,277.4,515.1c-1.2-0.9-2.8-1.5-4.4-1.5h-8.5c-4,0-7.3,3.3-7.3,7.3 v19.7c0,4,3.3,7.3,7.3,7.3h4.4h4.1c1.7,0,3.2-0.6,4.4-1.5c0.1-0.1,0.2-0.1,0.2-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M307.8,538.6c1.2,0.9,2.8,1.5,4.4,1.5h4.2h4.2c4,0,7.3-3.3,7.3-7.3v-19.7c0-4-3.3-7.3-7.3-7.3h-8.5 c-1.6,0-3.2,0.6-4.4,1.5c-1.8,1.3-2.9,3.5-2.9,5.8v19.7C304.9,535.2,306,537.3,307.8,538.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M268.9,547.9v8.2c0,3.6,3,6.6,6.6,6.6h17.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M292.6,557.7c0-0.1,10.1-0.1,17.2,0c3.7,0,6.6-2.9,6.6-6.6v-11"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M501,147.2c0,2.8-2.3,5.1-5.1,5.1s-5.1-2.3-5.1-5.1s2.3-5.1,5.1-5.1S501,144.4,501,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M483.7,139c2.6-3.9,7.1-6.5,12.1-6.5c5,0,9.5,2.5,12.1,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M474.6,132.9c4.6-6.8,12.4-11.3,21.2-11.3c8.8,0,16.6,4.4,21.2,11.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M466,127.1c6.5-9.6,17.4-15.9,29.9-15.9c12.4,0,23.3,6.2,29.8,15.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M421.2,70.2c-2.8-2.3-6.5-3.7-10.4-3.7c-3.4,0-6.6,1.1-9.2,2.8c-5.8,4-7.8,11.7-5.3,18.3l14.5,38.4 l14.5-38.4C427.6,81.4,426.2,74.3,421.2,70.2z M410.8,90.4c-3.8,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7 C417.8,87.3,414.6,90.4,410.8,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M162.2,148.9l-3.5-0.9c-0.5-0.1-0.9-0.6-1.1-1.1c-0.1-0.3-0.2-0.6-0.2-0.9c-0.2-0.5,0-1.1,0.4-1.5l2.5-2.6 c0.5-0.5,0.6-1.2,0.2-1.8l-2-3.5c-0.3-0.6-1-0.9-1.7-0.7l-3.5,0.9c-0.5,0.1-1.1,0-1.5-0.4c-0.2-0.2-0.4-0.4-0.6-0.6 c-0.4-0.4-0.6-0.9-0.4-1.5l0.9-3.5c0.2-0.7-0.1-1.4-0.7-1.7l-3.5-2c-0.6-0.3-1.3-0.2-1.8,0.2l-2.6,2.5c-0.4,0.4-1,0.5-1.5,0.4 c-0.3-0.1-0.6-0.2-0.9-0.2c-0.5-0.1-1-0.5-1.1-1.1l-0.9-3.5c-0.2-0.7-0.8-1.1-1.4-1.1h-4c-0.7,0-1.3,0.4-1.4,1.1l-0.9,3.5 c-0.1,0.5-0.6,0.9-1.1,1.1c-0.3,0.1-0.6,0.2-0.9,0.2c-0.5,0.2-1.1,0-1.5-0.4l-2.6-2.5c-0.5-0.5-1.2-0.6-1.8-0.2l-3.5,2 c-0.6,0.3-0.9,1-0.7,1.7l0.9,3.5c0.1,0.5,0,1.1-0.4,1.5c-0.2,0.2-0.4,0.4-0.7,0.6c-0.4,0.4-0.9,0.6-1.5,0.4l-3.5-0.9 c-0.7-0.2-1.3,0.1-1.7,0.7l-2,3.5c-0.3,0.6-0.2,1.3,0.2,1.8l2.5,2.6c0.4,0.4,0.5,1,0.4,1.5c-0.1,0.3-0.2,0.6-0.2,0.9 c-0.1,0.5-0.5,1-1.1,1.1l-3.5,0.9c-0.7,0.2-1.1,0.8-1.1,1.4v4c0,0.7,0.4,1.3,1.1,1.4l3.5,0.9c0.5,0.1,0.9,0.6,1.1,1.1 c0.1,0.3,0.2,0.6,0.2,0.9c0.2,0.5,0,1.1-0.4,1.5l-2.5,2.6c-0.5,0.5-0.6,1.2-0.2,1.8l2,3.5c0.3,0.6,1,0.9,1.7,0.7l3.5-0.9 c0.5-0.1,1.1,0,1.5,0.4c0.2,0.2,0.4,0.4,0.7,0.6c0.4,0.4,0.6,0.9,0.4,1.5l-0.9,3.5c-0.2,0.7,0.1,1.4,0.7,1.7l3.5,2 c0.6,0.3,1.3,0.2,1.8-0.2l2.6-2.5c0.4-0.4,1-0.5,1.5-0.4c0.3,0.1,0.6,0.2,0.9,0.2c0.5,0.1,1,0.5,1.1,1.1l0.9,3.5 c0.2,0.6,0.8,1.1,1.4,1.1h4c0.7,0,1.3-0.4,1.4-1.1l0.9-3.5c0.1-0.5,0.6-0.9,1.1-1.1c0.3-0.1,0.6-0.2,0.9-0.2 c0.5-0.2,1.1,0,1.5,0.4l2.6,2.5c0.5,0.5,1.2,0.6,1.8,0.2l3.5-2c0.6-0.3,0.9-1,0.7-1.7l-0.9-3.5c-0.1-0.5,0-1.1,0.4-1.5 c0.2-0.2,0.4-0.4,0.6-0.6c0.4-0.4,0.9-0.6,1.5-0.4l3.5,0.9c0.7,0.2,1.4-0.1,1.7-0.7l2-3.5c0.3-0.6,0.2-1.3-0.2-1.8l-2.5-2.6 c-0.4-0.4-0.5-1-0.4-1.5c0.1-0.3,0.2-0.6,0.2-0.9c0.1-0.5,0.5-1,1.1-1.1l3.5-0.9c0.6-0.2,1.1-0.8,1.1-1.4v-4 C163.3,149.7,162.9,149.1,162.2,148.9z M135.2,162c-5.3,0-9.7-4.3-9.7-9.6c0-5.3,4.3-9.6,9.7-9.6s9.6,4.3,9.6,9.6 C144.9,157.7,140.6,162,135.2,162z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "113.5,229.5 113.5,258.9 64.8,258.9 64.8,229.5 89.1,244.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "113.5,229.5 89.1,244.2 64.8,229.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.8,
    y: 229.5,
    className: "st4",
    width: 48.7,
    height: 29.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "64.8,229.5 89.1,244.2 113.5,229.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M688.3,91.6H630c-3.6,0-6.6,3-6.6,6.6v29.9c0,3.6,3,6.6,6.6,6.6h5.9l5.3,13.8c1.5,4,7.2,4,8.7,0l5.3-13.8 h33.1c3.6,0,6.6-3,6.6-6.6V98.2C694.9,94.6,691.9,91.6,688.3,91.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 636.6,
    y: 108.8,
    className: "st12",
    width: 8.8,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.7,
    y: 108.8,
    className: "st12",
    width: 8.8,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.9,
    y: 108.8,
    className: "st12",
    width: 8.8,
    height: 8.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M623.4,380.4C623.4,380.5,623.4,380.5,623.4,380.4c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6S623.4,377.4,623.4,380.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M634.5,373.9l45.6,14.4c-0.4,1.9-2.2,3.1-4,2.7l-52.7-10.5l2.5-3.6C627.8,374.1,631.3,372.9,634.5,373.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M617.8,321.2v53.7l-4-1.7c-3.1-1.3-5-4.5-4.7-7.9l5.2-47.5C616.3,317.7,617.8,319.2,617.8,321.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M612.2,380.4l-1.1,4.2c-0.9,3.3-3.8,5.6-7.2,5.8l-47.8,1.8c-0.3-1.9,1-3.6,2.9-3.9L612.2,380.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 617.8,
    y1: 479.2,
    x2: 617.8,
    y2: 386
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M617.8,374.9c3.1,0,5.6,2.5,5.6,5.6c0,0,0,0.1,0,0.1c0,3-2.5,5.5-5.6,5.5c-3.1,0-5.6-2.5-5.6-5.6 C612.2,377.4,614.7,374.9,617.8,374.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M612.2,380.4l-53.1,7.8c-1.9,0.3-3.2,2-2.9,3.9l47.8-1.8c3.4-0.1,6.3-2.5,7.2-5.8L612.2,380.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M617.8,374.9v-53.7c0-1.9-1.5-3.5-3.5-3.5l-5.2,47.5c-0.4,3.4,1.5,6.6,4.7,7.9L617.8,374.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M623.4,380.5l52.7,10.5c1.9,0.4,3.7-0.8,4-2.7l-45.6-14.4c-3.2-1-6.8,0.2-8.7,3L623.4,380.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.3,443.3C209.3,443.4,209.3,443.4,209.3,443.3c-0.1,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6S209.3,440.3,209.3,443.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M220.4,436.8l45.6,14.4c-0.4,1.9-2.2,3.1-4,2.7l-52.7-10.5l2.5-3.6C213.6,437,217.2,435.8,220.4,436.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M203.7,384.1v53.7l-4-1.7c-3.1-1.3-5-4.5-4.6-7.9l5.2-47.5C202.1,380.6,203.7,382.1,203.7,384.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.1,443.3l-1.1,4.2c-0.9,3.3-3.8,5.6-7.2,5.8l-47.8,1.8c-0.3-1.9,1-3.6,2.9-3.9L198.1,443.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 203.7,
    y1: 542.1,
    x2: 203.7,
    y2: 448.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M203.7,437.8c3.1,0,5.6,2.5,5.6,5.6c0,0,0,0.1,0,0.1c-0.1,3-2.5,5.5-5.6,5.5c-3.1,0-5.6-2.5-5.6-5.6 C198.1,440.3,200.6,437.8,203.7,437.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M198.1,443.3l-53.1,7.8c-1.9,0.3-3.2,2-2.9,3.9l47.8-1.8c3.4-0.1,6.3-2.5,7.2-5.8L198.1,443.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M203.7,437.8v-53.7c0-1.9-1.6-3.5-3.4-3.5l-5.2,47.5c-0.4,3.4,1.5,6.6,4.6,7.9L203.7,437.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M209.3,443.4l52.7,10.5c1.9,0.4,3.7-0.8,4-2.7l-45.6-14.4c-3.2-1-6.8,0.2-8.7,3L209.3,443.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.9,251.1C323.9,251.1,323.9,251.1,323.9,251.1c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6C321.4,245.5,323.9,248,323.9,251.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M335,244.5l45.6,14.4c-0.4,1.9-2.2,3.1-4,2.7l-52.7-10.5l2.5-3.6C328.2,244.7,331.8,243.5,335,244.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M318.3,191.8v53.7l-4-1.7c-3.1-1.3-5-4.6-4.6-7.9l5.2-47.5C316.7,188.3,318.3,189.9,318.3,191.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M312.7,251.1l-1.1,4.2c-0.9,3.3-3.8,5.6-7.2,5.7l-47.8,1.8c-0.3-1.9,1-3.6,2.9-3.9L312.7,251.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 318.3,
    y1: 349.8,
    x2: 318.3,
    y2: 256.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M318.3,245.5c3.1,0,5.6,2.5,5.6,5.6c0,0,0,0.1,0,0.1c0,3-2.5,5.5-5.6,5.5c-3.1,0-5.6-2.5-5.6-5.6 C312.7,248,315.2,245.5,318.3,245.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.7,251.1l-53.1,7.8c-1.9,0.3-3.2,2-2.9,3.9l47.8-1.8c3.4-0.1,6.3-2.5,7.2-5.8L312.7,251.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M318.3,245.5v-53.7c0-1.9-1.5-3.4-3.5-3.4l-5.2,47.5c-0.4,3.4,1.5,6.6,4.6,7.9L318.3,245.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M323.9,251.1l52.7,10.5c1.9,0.4,3.7-0.8,4-2.7L335,244.5c-3.2-1-6.8,0.2-8.7,3L323.9,251.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.8,272C277.8,272,277.8,272.1,277.8,272c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6S277.8,268.9,277.8,272z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289,265.5l45.6,14.4c-0.4,1.9-2.2,3.1-4,2.7l-52.7-10.5l2.5-3.6C282.2,265.7,285.7,264.5,289,265.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.2,212.7v53.7l-4-1.7c-3.1-1.3-5-4.5-4.6-7.9l5.2-47.5C270.7,209.3,272.2,210.8,272.2,212.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.7,272l-1.1,4.2c-0.9,3.3-3.8,5.6-7.2,5.8l-47.8,1.8c-0.3-1.9,1-3.6,2.9-3.9L266.7,272z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 272.2,
    y1: 370.8,
    x2: 272.2,
    y2: 277.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M272.2,266.4c3.1,0,5.6,2.5,5.6,5.6c0,0,0,0.1,0,0.1c0,3-2.5,5.5-5.6,5.5c-3.1,0-5.6-2.5-5.6-5.6 C266.7,268.9,269.2,266.4,272.2,266.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M266.7,272l-53.1,7.8c-1.9,0.3-3.2,2-2.9,3.9l47.8-1.8c3.4-0.1,6.3-2.5,7.2-5.8L266.7,272z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M272.2,266.4v-53.7c0-1.9-1.5-3.4-3.5-3.4l-5.2,47.5c-0.4,3.4,1.5,6.6,4.6,7.9L272.2,266.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M277.8,272.1l52.7,10.5c1.9,0.4,3.7-0.8,4-2.7L289,265.5c-3.2-1-6.8,0.2-8.7,3L277.8,272.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M564.7,463.1v4.8c0,4-3.3,7.3-7.3,7.3h-2.4v-19.5h2.4C561.4,455.7,564.7,459,564.7,463.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M522.7,477.2v4.8c0,4-3.3,7.3-7.3,7.3H513h-2.4c-4,0-7.3-3.3-7.3-7.3v-4.8c0-3.7,2.8-6.8,6.4-7.3 c0.3,0,0.6-0.1,1-0.1h4.8C519.4,469.9,522.7,473.2,522.7,477.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M532.3,489.7h-18.5l-0.8-0.4h2.4c4,0,7.3-3.3,7.3-7.3v-4.8c0-4-3.3-7.3-7.3-7.3h-4.8c-0.3,0-0.6,0-1,0.1 v0v-15.9c0-5.4,4.3-9.7,9.7-9.7h26c5.3,0,9.7,4.3,9.7,9.7v1.6v19.5v4.9c0,5.4-4.3,9.7-9.7,9.7H543L532.3,489.7L532.3,489.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "532.3,517.3 532.3,503.8 532.3,498 532.3,489.7 532.3,484 532.3,476.5 532.3,465.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 532.3,
    y1: 476.5,
    x2: 523.5,
    y2: 467.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 532.3,
    y1: 484,
    x2: 541.1,
    y2: 475.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M509.6,470v-15.9c0-5.4,4.3-9.7,9.7-9.7h26c5.3,0,9.7,4.3,9.7,9.7v1.6v19.5v4.9c0,5.4-4.3,9.7-9.7,9.7 H543h-10.8h-18.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "532.3,498 513.8,489.7 513,489.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M509.6,470c0.3,0,0.6-0.1,1-0.1h4.8c4,0,7.3,3.3,7.3,7.3v4.8c0,4-3.3,7.3-7.3,7.3H513h-2.4 c-4,0-7.3-3.3-7.3-7.3v-4.8C503.2,473.5,506,470.4,509.6,470z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M555,455.7h2.4c4,0,7.3,3.3,7.3,7.3v4.8c0,4-3.3,7.3-7.3,7.3H555"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 532.3,
    y1: 503.8,
    x2: 543,
    y2: 490.2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M452.8,533.9v4.8c0,4-3.3,7.3-7.3,7.3h-2.4v-19.5h2.4C449.5,526.6,452.8,529.9,452.8,533.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M410.8,548.1v4.8c0,4-3.3,7.3-7.3,7.3h-2.4h-2.4c-4,0-7.3-3.3-7.3-7.3v-4.8c0-3.7,2.8-6.8,6.4-7.3 c0.3,0,0.6-0.1,1-0.1h4.8C407.5,540.7,410.8,544,410.8,548.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M420.4,560.6h-18.5l-0.9-0.4h2.4c4,0,7.3-3.3,7.3-7.3v-4.8c0-4-3.3-7.3-7.3-7.3h-4.8c-0.3,0-0.6,0-1,0.1 v0v-15.9c0-5.3,4.3-9.7,9.7-9.7h26c5.4,0,9.7,4.3,9.7,9.7v1.7V546v4.8c0,5.4-4.3,9.7-9.7,9.7h-2.2L420.4,560.6L420.4,560.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "420.4,588.1 420.4,574.6 420.4,568.8 420.4,560.6 420.4,554.9 420.4,547.3 420.4,536.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 420.4,
    y1: 547.3,
    x2: 411.5,
    y2: 538.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 420.4,
    y1: 554.9,
    x2: 429.2,
    y2: 546.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M397.7,540.8v-15.9c0-5.3,4.3-9.7,9.7-9.7h26c5.4,0,9.7,4.3,9.7,9.7v1.7V546v4.8c0,5.4-4.3,9.7-9.7,9.7 h-2.2h-10.8h-18.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "420.4,568.8 401.9,560.6 401.1,560.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M397.7,540.8c0.3,0,0.6-0.1,1-0.1h4.8c4,0,7.3,3.3,7.3,7.3v4.8c0,4-3.3,7.3-7.3,7.3h-2.4h-2.4 c-4,0-7.3-3.3-7.3-7.3v-4.8C391.3,544.4,394.1,541.3,397.7,540.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M443,526.6h2.4c4,0,7.3,3.3,7.3,7.3v4.8c0,4-3.3,7.3-7.3,7.3H443"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 420.4,
    y1: 574.6,
    x2: 431.1,
    y2: 561.1
  })))), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "495.8,169.6 495.8,233.3 517,233.3 517,261.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "645.4,164.5 645.4,200 683.6,200 683.6,268.7 564.7,268.7 564.7,290  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.1,268.7 89.1,288.2 182,288.2 182,332.7 243.3,332.7 243.3,359.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "135.2,198.3 135.2,233.3 237.6,233.3 237.6,258.9  "
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartcitybremove);
export default __webpack_public_path__ + "static/media/smartcitybremove.97b57c2f0149b26c585aa1cf53590afc.svg";
export { ForwardRef as ReactComponent };